import { render, staticRenderFns } from "./VerdictSummaryDetails.vue?vue&type=template&id=18049b75&scoped=true"
import script from "./VerdictSummaryDetails.vue?vue&type=script&lang=js"
export * from "./VerdictSummaryDetails.vue?vue&type=script&lang=js"
import style0 from "./VerdictSummaryDetails.vue?vue&type=style&index=0&id=18049b75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18049b75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18049b75')) {
      api.createRecord('18049b75', component.options)
    } else {
      api.reload('18049b75', component.options)
    }
    module.hot.accept("./VerdictSummaryDetails.vue?vue&type=template&id=18049b75&scoped=true", function () {
      api.rerender('18049b75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VerdictSummaryDetails.vue"
export default component.exports